{
  "id": "level",
  "text": "TOP_LEVEL",
  "variant": "locked",
  "src": "/proof/video/level.mp4",
  "poster": "/proof/video/level-poster.jpg",
  "posterTime": 3.2,
  "duration": 3.583,
  "fps": 24.0,
  "keyframes": [
    {
      "t": 0.0,
      "top": 0.4435,
      "left": 0.3192,
      "width": 0.3675,
      "height": 0.095
    },
    {
      "t": 0.5,
      "top": 0.4389,
      "left": 0.2244,
      "width": 0.5743,
      "height": 0.1484
    },
    {
      "t": 1.0,
      "top": 0.4104,
      "left": 0.0579,
      "width": 0.8937,
      "height": 0.231
    },
    {
      "t": 1.5,
      "top": 0.3483,
      "left": 0.0,
      "width": 1.0,
      "height": 0.3426
    },
    {
      "t": 2.0,
      "top": 0.3106,
      "left": 0.0,
      "width": 1.0,
      "height": 0.4428
    },
    {
      "t": 2.5,
      "top": 0.2841,
      "left": 0.0,
      "width": 1.0,
      "height": 0.4945
    },
    {
      "t": 3.0,
      "top": 0.3051,
      "left": 0.0,
      "width": 0.9866,
      "height": 0.4884
    },
    {
      "t": 3.5,
      "top": 0.3027,
      "left": 0.0,
      "width": 0.9759,
      "height": 0.4831
    },
    {
      "t": 3.542,
      "top": 0.3029,
      "left": 0.0,
      "width": 0.9755,
      "height": 0.4829
    }
  ]
}
